import styled from 'styled-components'

const GradeStyled = styled.div`

  height: calc(100vh - 310px);
  position: relative;

`
export default GradeStyled
